import { Body } from "@vds/typography";
import { Box, Tooltip } from "@mui/material";
import {
  getTimeBasedOnGivenDate,
  parseColorsFromString,
} from "../../../global/utility/Utils";
import { EVENTS_INFO_CONSTANTS } from "../../../global/constants/constants";
import { ReactComponent as Info } from '../../../assets/info.svg';

const EventInfoContainer = ({
  videoUploadSpeed,
  stateData,
  LocationName,
  CreatedAt,
  date,
  isDetectionApp
}) => {
  const displayColors = parseColorsFromString(stateData?.custom?.objectColor); 

  const tooltipContent = (
    <Box>
      <Body viewport="desktop" size="medium">
        {`${EVENTS_INFO_CONSTANTS.EVENT_VIDEO_UPLOAD_SPEED.replace("[uploadSpeed]", videoUploadSpeed)}`}
      </Body>
    </Box>
  );

  return (  
  <>
    <div className="event_info_row">
      <Body size="medium" bold>
        Event occured &nbsp;
      </Body>
      {CreatedAt && (
        <Body size="medium">
          at{` ${getTimeBasedOnGivenDate(CreatedAt)}, on ${date}`} &nbsp;
          {videoUploadSpeed && (
            <Tooltip
              placement={"bottom"}
              arrow
              title={tooltipContent}
              className="upload-speed_tooltip"
              slotProps={{
                tooltip: {
                  sx: {
                    backgroundColor: "white",
                    border: "1px solid black",
                    "& .MuiTooltip-arrow": {
                      backgroundColor: "white"
                    }
                  }
                }
              }}
            >
              <sup>
                <Info />
              </sup>
            </Tooltip>
          )}
        </Body>
      )}
    </div>
    <div className="event_info_row">
      <Body size="medium">
        <strong>Location:</strong>&nbsp;{LocationName}
      </Body>
    </div>
    <div className="event_info_row">
      <Body size="medium" bold>
        Event ID: &nbsp;
      </Body>
      <Body size="medium">
        {stateData?.incidentNumber ? stateData?.incidentNumber : "000000000"}
      </Body>
    </div>
      {isDetectionApp && stateData?.custom?.objectColor && (
        <div className="event_info_colors_row">
          <Body size="medium" bold>
            Colors Detected: &nbsp;
          </Body>
          <div className="event_info_colors_container">
            {displayColors.map((color, index) => (
              <span
                key={index}
                className="event_info_color_dot"
                style={{ backgroundColor: color }}
              ></span>
            ))}
          </div>
        </div>
      )}
  </>
)}

export default EventInfoContainer;